import React, { Component } from 'react';
import { ReactComponent as IbmLogoSvg } from 'app/assets/logos/ibm-cloud.svg';

export default class IbmLogo extends Component {
  render() {
    const { iconSize, color, ...props } = this.props;
    return <IbmLogoSvg {...props} />;
  }
}
